module.exports = __webpack_public_path__ + "img/bs9.c5a7f4bd.png";